module.exports = function isNil(x) {
  return x === null || x === void 0;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/isNil.js
 ** module id = 86
 ** module chunks = 0
 **/